import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { SiteReportUnitAnalysis } from '@/libs/fleet-api/services/types';
import { Button, Divider, Form, Input } from 'antd';
import { FC } from 'react';
import { useCCAVisitReportVerificationPage } from './VisitReportVerificationPage';
import { submitCCASiteReportUnitAnalysis } from '@/libs/fleet-api/services/visit-reports';
import { useMutation } from '@tanstack/react-query';

export const useCCASiteVisitReportUnitForm = () => {
	return useForm<SiteReportUnitAnalysis<'payload'>>();
};

const CCASiteVisitReportUnit: FC<{ onSave: () => void }> = ({ onSave }) => {
	const { siteReport, surveyInformation } = useCCAVisitReportVerificationPage();
	const { form, fieldName } = useForm<SiteReportUnitAnalysis<'payload'>>();

	const submitCCASiteReportUnitAnalysisMutation = useMutation({
		mutationFn: submitCCASiteReportUnitAnalysis,
	});

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					additionalUnitInfo: siteReport?.additionalUnitInfo,
					operatingUnitVerification: siteReport?.operatingUnitVerification,
					unitNeedsVerification: siteReport?.unitNeedsVerification,
					unitVerificationNotes:
						siteReport?.unitAnalysis?.unitVerificationNotes,
				} as SiteReportUnitAnalysis<'payload'>
			}
			onFinish={async (values) => {
				await submitCCASiteReportUnitAnalysisMutation.mutateAsync(values);
				onSave?.();
			}}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('unitNeedsVerification')}
				label="Verifikasi Kebutuhan Unit"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('operatingUnitVerification')}
				label="Verifikasi Unit yang sedang Beroperasi"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalUnitInfo')}
				label="FRM Notes"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				{form.getFieldValue(fieldName('additionalUnitInfo')) ?? '-'}
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('unitVerificationNotes')}
				label="Verification Notes"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Button
				type="primary"
				style={{
					width: 200,
					display: 'block',
					marginLeft: 'auto',
					marginTop: 20,
				}}
				loading={submitCCASiteReportUnitAnalysisMutation.isPending}
				onClick={() => {
					form.submit();
				}}
			>
				NEXT
			</Button>
		</Form>
	);
};

export default CCASiteVisitReportUnit;
